import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useErrorStore = defineStore('error', () => {
    const errorMessage = ref('')

    const setGlobalError = (message: string) => {
        errorMessage.value = message
    }

    const clearGlobalError = () => {
        errorMessage.value = ''
    }

    return {
        errorMessage,
        setGlobalError,
        clearGlobalError,
    }
})
